import './RecipeCard.css';
import { useLanguage } from '../LanguageContext';
import translations from '../translations';

function formatTime(mins) {
  if (!mins) return null;
  if (mins < 60) return `${mins}m`;
  const h = Math.floor(mins / 60);
  const m = mins % 60;
  return m > 0 ? `${h}h ${m}m` : `${h}h`;
}

function RecipeCard({ recipe, onClick, onToggleFavourite, isAdmin, visitorLiked, animateDelay, showDraft }) {
  const { language } = useLanguage();
  const t = translations[language];
  const totalTime = (recipe.prep_time_mins || 0) + (recipe.cook_time_mins || 0);
  // For visitors (not logged in), heart state comes from localStorage via visitorLiked prop
  const isActive = isAdmin ? recipe.is_favourite : (visitorLiked || false);

  function handleHeartClick(e) {
    e.stopPropagation();
    if (onToggleFavourite) onToggleFavourite(recipe.id, !isActive);
  }

  return (
    <div
      className={`recipe-card${animateDelay !== undefined ? ' animate-in' : ''}`}
      style={animateDelay ? { animationDelay: animateDelay } : undefined}
      onClick={onClick}
    >
      <div className="recipe-card__image-placeholder">
        {recipe.image_url
          ? <img src={recipe.image_url} alt={recipe.title} />
          : <span className="recipe-card__no-image">🍽</span>
        }
        {/* Heart — visible to all users */}
        <button
          className={`recipe-card__heart${isActive ? ' recipe-card__heart--active' : ''}`}
          onClick={handleHeartClick}
          aria-label={isActive ? 'Remove from favourites' : 'Add to favourites'}
        >
          {isActive ? '♥' : '♡'}
        </button>
        {showDraft && !recipe.is_published && (
          <span className="recipe-card__draft-badge">Draft</span>
        )}
        {recipe.is_traditional && (
          <span className="recipe-card__traditional" title={t.traditionalTooltip}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 2C10.5 4.5 7 5 5 4c1 3 0 6-2 7.5 2 .5 3.5 2 4 4 1-1.5 2.5-2.5 4-2.5s3 1 4 2.5c.5-2 2-3.5 4-4C17 10 16 7 17 4c-2 1-5.5.5-5-2z" stroke="#7a5c2e" strokeWidth="1.5" strokeLinejoin="round"/>
              <circle cx="12" cy="12" r="2" fill="#7a5c2e"/>
            </svg>
          </span>
        )}
      </div>
      <div className="recipe-card__body">
        <span className="recipe-card__category">{t.categories[recipe.category] || recipe.category}</span>
        <h2 className="recipe-card__title">{recipe.title}</h2>
        {recipe.owner_name && (
          <span className="recipe-card__owner">from {recipe.owner_name}</span>
        )}
      </div>
    </div>
  );
}

export default RecipeCard;
